/** 使用率のバー。9割を超えたら危険色にする。 */
export function DiskUsageBar({
	usedBytes,
	totalBytes,
}: {
	usedBytes: number | null;
	totalBytes: number | null;
}) {
	const ratio =
		usedBytes !== null && totalBytes !== null && totalBytes > 0
			? Math.min(1, usedBytes / totalBytes)
			: 0;
	return (
		<div
			style={{
				height: 4,
				borderRadius: "var(--radius-full)",
				background: "var(--surface-2)",
				overflow: "hidden",
			}}
		>
			<div
				style={{
					width: `${ratio * 100}%`,
					height: "100%",
					borderRadius: "var(--radius-full)",
					background: ratio >= 0.9 ? "var(--danger-solid)" : "var(--accent-solid)",
				}}
			/>
		</div>
	);
}
